<template>
    <div class="modal modal-blur fade" ref="sl" tabindex="-1">
        <slot></slot>
    </div>
</template>
<script>
import { useAlert } from '../../stores/alert';

export default {
    name: 'Modal',
    props: {
        type: {
            required: true,
        },
        backdrop: {
            required: false,
            default: true
        },
        keyboard: {
            required: false,
            default: true
        },
        focus: {
            required: false,
            default: true
        }
    },

    data() {
        return {
            modal: null,
        };
    },

    mounted() {
        let options = {
            backdrop: this.backdrop,
            keyboard: this.keyboard,
            focus: this.focus,
        }

        let el = this.$refs['sl'];

        this.modal = new window.bootstrap.Modal(el, options);

        el.addEventListener('hidden.bs.modal', function() {
            if (this.type == 'post-modal') {
                console.log("POST"); // Post Maker will 99% be a page and not a modal
            } else if (this.type == 'alert') {
                const alertStore = useAlert();
                alertStore.$patch({openDialog: false});
            }
            this.$emit('modal-closed', this.type);
        }.bind(this));
    },

    methods: {
        show() {
            this.modal.show();
        },

        hide() {
            this.modal.hide();
        }
    },

    watch: {
        $route(to, from) {
            this.hide(); // Close the modal if the route changes
        }
    }
}
</script>
